import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { ROUTES } from './profileInfo/constant/Routes';

function CartSuccessModal({ show, onHide }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className='cart-success-modal'
      backdropClassName='cart-success-modal-backdrop'
      dialogClassName='cart-success-modal-dialog'
      style={{ zIndex: 10000000005 }}
      dir='rtl'
    >
      <Modal.Body className='cart-success-modal-body'>
        <div className='cart-success-modal-icon' aria-hidden='true'>
          <i className='fas fa-shopping-basket' />
          <i className='fas fa-box cart-success-modal-icon-package' />
        </div>
        <h3 className='cart-success-modal-title'>چه سلیقه‌ای!</h3>
        <p className='cart-success-modal-subtitle'>سبد خرید شما به‌روز شد!</p>
        <Link to={ROUTES.MARKET_PLACE} className='cart-success-modal-btn cart-success-modal-btn--primary' onClick={onHide}>
          مشاهده سبد خرید
        </Link>
        <button type='button' className='cart-success-modal-btn cart-success-modal-btn--outline' onClick={onHide}>
          ادامه خرید
        </button>
      </Modal.Body>
    </Modal>
  );
}

CartSuccessModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default CartSuccessModal;
